<template>
    <div class="page-auth">
        <div class="login-page">
            <div class="content-form flex flex-col items-center justify-center bg-transparent h-full">
                <div class="mx-auto grid w-4/5 md:w-3/4 gap-6 bg-white py-8 px-3 rounded-15">
                    <div class="grid gap-2 text-center justify-items-center items-center">
                        <div class="w-3/4 mb-3 flex justify-center">
                            <img class="logo-img" :src="logoUrl"
                            alt="cyberforceacademy logo" v-if="isLogoUrl">
                            <img class="" src="../../assets/auth/images/spec-brand-1.svg"
                            alt="cyberforceacademy logo" v-else>
                        </div>
                        
                        <div class="text-center">
                            <div v-if="isProcessing" class="flex flex-col items-center gap-4">
                                <div class="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"></div>
                                <h2 class="text-xl font-medium text-gray-800">Traitement de la connexion SSO...</h2>
                                <p class="text-gray-600">Veuillez patienter pendant que nous finalisons votre connexion.</p>
                            </div>
                            
                            <div v-else-if="isSuccess" class="flex flex-col items-center gap-4">
                                <div class="text-green-500 text-4xl">✓</div>
                                <h2 class="text-xl font-medium text-gray-800">Connexion réussie!</h2>
                                <p class="text-gray-600">Redirection vers le tableau de bord...</p>
                            </div>
                            
                            <div v-else-if="isError" class="flex flex-col items-center gap-4">
                                <div class="text-red-500 text-4xl">✗</div>
                                <h2 class="text-xl font-medium text-gray-800">Erreur de connexion</h2>
                                <p class="text-gray-600">{{ errorMessage }}</p>
                                <button @click="redirectToLogin" class="px-4 py-2 bg-spect text-white rounded hover:bg-opacity-90">
                                    Retour à la connexion
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { getAPI } from '@/axios-api.js'

export default {
    name: 'SSOCallback',
    data() {
        return {
            isProcessing: true,
            isSuccess: false,
            isError: false,
            errorMessage: '',
        }
    },
    computed: {
        isLogoUrl: {
            get() {
                return localStorage.getItem("domainLogo") && localStorage.getItem("domainLogo") != ""
            },
            set(value) {
                console.log(value)
            }
        },
        logoUrl() {
            if (localStorage.getItem("domainLogo") && localStorage.getItem("domainLogo") != "") {
                return localStorage.getItem("domainLogo")
            }
            return "../../assets/auth/images/spec-brand-1.svg"
        }
    },
    methods: {
        async handleSSOCallback() {
            try {
                const params = new URLSearchParams(window.location.search);
                
                // Extract parameters from URL - handle both old and new formats
                const success = params.get('success');
                const accessToken = params.get('access_token') || params.get('access');
                const refreshToken = params.get('refresh_token') || params.get('refresh');
                const email = params.get('email');
                const name = params.get('name');
                const userParam = params.get('user');
                const created = params.get('created');
                const errorParam = params.get('error');
                
                console.log('SSO Callback parameters:', {
                    success,
                    accessToken: accessToken ? 'present' : 'missing',
                    refreshToken: refreshToken ? 'present' : 'missing',
                    email,
                    name,
                    user: userParam ? 'present' : 'missing',
                    created,
                    error: errorParam
                });
                
                // If the callback indicates failure, show error message
                if (success === 'false' || (!accessToken && !refreshToken)) {
                    const decodedError = errorParam ? decodeURIComponent(errorParam) : "Une erreur inattendue s'est produite.";
                    throw new Error(decodedError);
                }

                // Check if we have the required parameters for success
                if (success === 'true' && accessToken && refreshToken) {
                    // Store tokens
                    localStorage.setItem('token', accessToken);
                    localStorage.setItem('refresh_token', refreshToken);
                    
                    // Parse user data to determine if new or existing user
                    let isNewUser = false;
                    let userData = null;
                    
                    // Handle user data - prioritize user param if available
                    if (userParam) {
                        try {
                            // Decode the user parameter (it's URL encoded)
                            const decodedUser = decodeURIComponent(userParam);
                            
                            // Parse the user data (it's a Python dict representation)
                            userData = this.parseUserData(decodedUser);
                            
                            // Determine if user is new based on created parameter or is_completed flag
                            isNewUser = created === 'true' || userData.is_completed === false || userData.is_completed === 'False';
                            
                            // Store user information
                            localStorage.setItem('user', userData.id);
                            localStorage.setItem('firstname', userData.firstname);
                            localStorage.setItem('lastname', userData.lastname);
                            localStorage.setItem('type_account', userData.type_account);
                            localStorage.setItem('role', userData.role);
                            localStorage.setItem('organisation', userData.organisation);
                            localStorage.setItem('code_organisation', userData.code_organisation);
                            localStorage.setItem('service', userData.service || '');
                            localStorage.setItem('is_completed', userData.is_completed);
                            
                        } catch (parseError) {
                            console.warn('Could not parse SSO user data:', parseError);
                            // Fallback to email/name if user parsing fails
                            this.handleFallbackUserData(email, name);
                            // If we can't parse user data, check created parameter
                            isNewUser = created === 'true';
                        }
                    } else {
                        // Fallback to email/name if no user param
                        this.handleFallbackUserData(email, name);
                        // If no user param, check created parameter
                        isNewUser = created === 'true';
                    }
                    
                    // Store email if available
                    if (email) {
                        localStorage.setItem('email', decodeURIComponent(email));
                    }
                    
                    // Fetch organization colors
                    await this.fetchOrganizationColors();
                    
                    this.isProcessing = false;
                    this.isSuccess = true;
                    
                    console.log('Is new user:', isNewUser);
                    
                    // Redirect based on whether user is new or existing
                    if (isNewUser) {
                        // New user - redirect to activation page
                        console.log('New SSO user detected, redirecting to activation page...');
                        // Store email and name for activation form
                        if (email) localStorage.setItem('sso_email', email);
                        if (name) localStorage.setItem('sso_name', name);
                        setTimeout(() => {
                            window.location.href = '/sso/account';
                        }, 2000);
                    } else {
                        // Existing user - redirect to dashboard
                        console.log('Existing SSO user detected, redirecting to dashboard...');
                        setTimeout(() => {
                            this.redirectToDashboard();
                        }, 2000);
                    }
                    
                } else {
                    throw new Error('Paramètres de connexion SSO manquants ou invalides');
                }
                
            } catch (error) {
                this.isProcessing = false;
                this.isError = true;
                this.errorMessage = error && error.message ? error.message : 'Une erreur s\'est produite lors de la connexion SSO.';
            }
        },
        
        parseUserData(userString) {
            // Parse Python dict representation to JavaScript object
            // Example: "{'id': UUID('111d6182-3ced-4ae1-acd9-e89efc74fffa'), 'firstname': 'NKUBITO', ...}"
            
            // Remove outer braces and quotes
            let cleaned = userString.replace(/^\{|\}$/g, '');
            
            // Replace Python UUID() with just the string
            cleaned = cleaned.replace(/UUID\(['"]([^'"]+)['"]\)/g, '$1');
            
            // Replace Python True/False with JavaScript true/false
            cleaned = cleaned.replace(/\bTrue\b/g, 'true');
            cleaned = cleaned.replace(/\bFalse\b/g, 'false');
            
            // Replace Python None with JavaScript null
            cleaned = cleaned.replace(/\bNone\b/g, 'null');
            
            // Replace single quotes with double quotes for JSON parsing
            cleaned = cleaned.replace(/'/g, '"');
            
            // Parse as JSON
            return JSON.parse(cleaned);
        },
        
        handleFallbackUserData(email, name) {
            // Fallback method when user param is not available
            if (email) {
                localStorage.setItem('email', decodeURIComponent(email));
            }
            
            if (name) {
                const decodedName = decodeURIComponent(name);
                // Split name into firstname and lastname
                const nameParts = decodedName.split(' ');
                const firstname = nameParts[0] || '';
                const lastname = nameParts.slice(1).join(' ') || '';
                
                localStorage.setItem('firstname', firstname);
                localStorage.setItem('lastname', lastname);
            }
            
            // Note: Additional user data will be fetched from token in the main callback handler
        },
        
        async fetchUserData(accessToken) {
            try {
                // Try to decode user info from JWT token
                const tokenParts = accessToken.split('.');
                if (tokenParts.length === 3) {
                    const payload = JSON.parse(atob(tokenParts[1]));
                    console.log('JWT payload:', payload);
                    
                    if (payload.user_id) {
                        localStorage.setItem('user', payload.user_id);
                    }
                }
                
                // Make API call to get user details
                const response = await getAPI.get('accounts/user/');
                if (response.status === 200 && response.data) {
                    const userData = response.data;
                    localStorage.setItem('user', userData.id);
                    localStorage.setItem('firstname', userData.firstname || localStorage.getItem('firstname') || '');
                    localStorage.setItem('lastname', userData.lastname || localStorage.getItem('lastname') || '');
                    localStorage.setItem('organisation', userData.organisation || '');
                    localStorage.setItem('type_account', userData.type_account || '');
                    localStorage.setItem('role', userData.role || '');
                    localStorage.setItem('image', userData.image || null);
                }
            } catch (error) {
                console.warn('Could not fetch user data:', error);
                // Continue with available data
            }
        },
        
        async fetchOrganizationColors() {
            try {
                const organisation = localStorage.getItem('organisation');
                if (organisation) {
                    const response = await getAPI.get(`organisations/${organisation}/`);
                    if (response.status === 200) {
                        const primary = response.data.primary_color;
                        const secondary = response.data.secondary_color;
                        
                        localStorage.setItem("primary_color", primary || "#0cbcc6");
                        localStorage.setItem("secondary_color", secondary || "#132c4e");
                    }
                }
            } catch (error) {
                console.warn('Could not fetch organization colors:', error);
                // Set default colors
                localStorage.setItem("primary_color", "#0cbcc6");
                localStorage.setItem("secondary_color", "#132c4e");
            }
        },
        
        redirectToDashboard() {
            const redirectPath = localStorage.getItem('currentPath') || '/dashboard';
            window.location.href = redirectPath;
        },
        
        redirectToLogin() {
            window.location.href = '/login';
        }
    },
    
    async mounted() {
        await this.handleSSOCallback();
    },
    
    async beforeRouteEnter() {
        try {
            const rootUrl = window.location.host;
            console.log(rootUrl);
            const response = await axios.post(`${process.env.VUE_APP_BASE_URL}organisations/organisation_details`, {
                url_access: rootUrl
            });
            console.log(response)
            if (response.status === 200) {
                const data = response.data
                if (data.logo && data.logo !== "null" && data.logo !== "undefined") {
                    localStorage.setItem("domainLogo", data.logo);
                } else {
                    // Remove the item if it's null to ensure fallback to default logo
                    localStorage.removeItem("domainLogo");
                }
            }
        } catch (error) {
            console.warn('Could not fetch organization logo:', error);
        }
    }
}
</script>

<style lang="scss" scoped>
@use "../../assets/scss/tailwinds.scss";
</style>
